import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { InsideSection } from '../components/sales/InsideSection';
import { TransformationSection } from '../components/sales/TransformationSection';
import { BenefitSection } from '../components/sales/BenefitSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { KitContentsSection } from '../components/sales/KitContentsSection';
import { LibrarySection } from '../components/sales/LibrarySection';
import { AfterPurchaseSection } from '../components/sales/AfterPurchaseSection';
import { FaqSection } from '../components/sales/FaqSection';
import { CheckoutSection } from '../components/sales/CheckoutSection';
import { SiteFooter } from '../components/sales/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-194" data-mp="3qoyrsmq1uexj">
      <header className="border-b border-brand-charcoal/10 bg-brand-paper" data-id="element-195" data-mp="3vobbiylmj5vw">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-196" data-mp="3ajgjv5c1m01n">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-197" data-mp="35t9u325so9ht">
            Nail Educator Ready™
          </p>
        </div>
      </header>

      <main data-id="element-198" data-mp="2vuu3d0aoj28u">
        <HeroSection data-id="element-199" data-mp="2vv3uir7gnfg4" />
        <InsideSection data-id="element-200" data-mp="2vvvet5vlxqr3" />
        <TransformationSection data-id="element-201" data-mp="2vweyos4tip7r" />
        <BenefitSection data-id="element-202" data-mp="3tikn1xgwkzle" />
        <AudienceSection data-id="element-203" data-mp="3tj43f9qwnfxb" />
        <KitContentsSection data-id="element-204" data-mp="3th9me6ir87yi" />
        <LibrarySection data-id="element-205" data-mp="3tghx1dfr36go" />
        <AfterPurchaseSection data-id="element-206" data-mp="3ojr9y65j3alr" />
        <FaqSection data-id="element-207" data-mp="3okj6bj6y9cd3" />
        <CheckoutSection data-id="element-208" data-mp="3okarhlr9nwz9" />
      </main>

      <SiteFooter data-id="element-209" data-mp="3jk4vjtdyrobd" />
    </div>;
}